define([
  'underscore',
  'es6!sumo/util',
  'es6!launcher/util/listbuilder/wysiwyg/util',
  'es6!launcher/util/listbuilder/constants',
], (_, Util, WysiwygUtil, Constants) => {

  const TEXT_TEMPLATE = {
    type: 'text',
    text: 'Sign up today for free and be the first to get notified on new updates.\n',
    style: {
      width: '300px',
      fontSize: '16px',
      color: 'rgba(73,82,89,1)',
    },
  };

  const HTML_TEMPLATE = {
    type: 'html',
    html: '<button style="padding: 10px 20px; background-color: #4CAF50; color: white; border: none; border-radius: 5px; cursor: pointer;">Click Me</button>',
    style: {
      width: '300px',
      height: '100px',
      fontSize: '16px',
      color: 'rgba(73,82,89,1)',
    },
  };

  const PRIZE_TEXT_TEMPLATE = {
    ...TEXT_TEMPLATE,
    text: '{prize_text}',
  }

  const PRIZE_TEMPLATE = {
    ...TEXT_TEMPLATE,
    text: '{prize}',
  };

  const IMAGE_TEMPLATE = {
    type: 'image',
    mediaId: 'b1801a730b06202ceb4200f702a16fa9c3eb2511e57f9edb9913990abdd13eb6',
    mediaType: 'image',
    fill: 'cover',
    style: {
      width: '100px',
      height: '100px',
    },
  };

  const BACKGROUND_TEMPLATE = {
    type: 'background',
    fill: 'cover',
    style: {
      width: '550px',
      height: '270px',
      backgroundColor: 'rgba(239,239,239,1)',
      borderRadius: '6px',
      borderTopLeftRadius: '6px',
      borderTopRightRadius: '6px',
      borderBottomLeftRadius: '6px',
      borderBottomRightRadius: '6px',
    },
  };

  const BUTTON_TEMPLATE = {
    type: 'button',
    action: 'submit',
    text: 'Subscribe Now',
    style: {
      width: '350px',
      height: '50px',
      fontSize: '16px',
      fontWeight: '700',
      fontFamily: "'Open Sans',sans-serif",
      lineHeight: '1.5',
      color: 'rgba(255,255,255,1)',
      backgroundColor: 'rgba(15,116,181,1)',
      borderRadius: '4px',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
    },
  };

  const SOCIAL_BUTTON_TEMPLATE = {
    type: 'socialButton',
    socialChannel: 'twitter',
  };

  const CLOSE_BUTTON_TEMPLATE = {
    type: 'image',
    action: 'close',
    mediaId: '4720b373859b04afd757651cd6d7fb201973415db9d188b41026f6b394d52c88',
    mediaType: 'svg',
    style: {
      width: '28px',
      height: '28px',
    },
  };

  const TEXT_FIELD_TEMPLATE = {
    type: 'textField',
    placeholder: 'Enter your Email',
    name: 'email',
    required: true,
    style: {
      width: '350px',
      height: '52px',
      fontSize: '16px',
      fontFamily: "'Open Sans',sans-serif",
      lineHeight: '1.5',
      textAlign: 'left',
      backgroundColor: 'rgba(255,255,255,1)',
      borderWidth: '1px',
      borderTopWidth: '1px',
      borderBottomWidth: '1px',
      borderLeftWidth: '1px',
      borderRightWidth: '1px',
      borderColor: 'rgba(204,204,204,1)',
    },
  };

  const CHECKBOX_TEMPLATE = {
    type: 'checkbox',
    text: 'Opt in to receive news and updates',
    name: 'opt-in',
    style: {
      width: '300px',
      fontSize:"14px",
      lineHeight: "1.5",
      fontFamily:"'Open Sans',sans-serif",
    },
  };

  const DROPDOWN_TEMPLATE = {
    type: 'dropdown',
    name: 'dropdown',
    placeholder: 'Select an option',
    options: [
      { label: 'Option 1', value: '' },
    ],
    style: {
      backgroundColor: 'rgba(255,255,255,1)',
      width: '200px',
    },
  };

  const RADIO_TEMPLATE = {
    type: 'radio',
    name: 'radio',
    label: 'Select an option',
    options: [
      { label: 'Option 1', value: '' },
      { label: 'Option 2', value: '' },
    ],
    style: {
      width: '200px',
    },
  };

  const CHECKBOX_GROUP_TEMPLATE = {
    type: 'checkboxGroup',
    name: 'checkboxGroup',
    label: 'Select options',
    options: [
      { label: 'Option 1', value: '' },
      { label: 'Option 2', value: '' },
    ],
    style: {
      width: '200px',
    },
  };

  const HIDDEN_TEMPLATE = {
    type: 'hidden',
    name: 'hidden',
  };

  // Default end, timezone, and format will be added by sanitize;
  const COUNTDOWN_TEMPLATE = {
    type: 'countdown',
    style: {
      width: '300px',
      fontSize: '16px',
      color: 'rgba(73,82,89,1)',
    },
  };

  const DISCOUNT_TEMPLATE = {
    type: 'discount',
    text: '{discount_code}',
    copiedText: 'Copied!',
    copyToClipboard: true,
    style: {
      width: '350px',
      height: '50px',
      fontSize: '16px',
      fontWeight: '700',
      fontFamily: "'Open Sans',sans-serif",
      lineHeight: '1.5',
      color: 'rgba(255,255,255,1)',
      backgroundColor: 'rgba(15,116,181,1)',
      borderRadius: '4px',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
    },
  };

  const SCALED_STAGE_TEMPLATE = {
    type: 'scaledStage',
    style: {
      width: '500px',
      height: '500px',
    },
    childComponents: [],
  };

  const GRID_COLUMN_TEMPLATE = {
    type: 'gridColumn',
    layouts: { small: 12 },
    contentAlign: 'center',
    childComponents: [BACKGROUND_TEMPLATE, SCALED_STAGE_TEMPLATE],
  };

  const GRID_ROW_TEMPLATE = {
    type: 'gridRow',
    childComponents: [GRID_COLUMN_TEMPLATE],
  };

  const TAB_TEMPLATE = {
    type: 'tab',
    showType: 'before',
    mode: 'corner',
    position: 'top-right',
    size: 'medium',
    text: 'Subscribe',
    style: {
      color: '#FFFFFF',
      backgroundColor: '#0F74B5',
      fontSize: '18px',
      fontWeight: '700',
      fontFamily: "'Open Sans',sans-serif",
    },
  };

  const GAME_TEMPLATE = {
    type: 'game',
    gameType: 'slot-machine',
    muteAudio: false,
    options: [
      {
        mediaId: null,
        label: '',
        weight: 0,
        prizeType: 'none',
        discountCampaignId: null,
        contentMediaId: null,
      },
      {
        mediaId: null,
        label: '',
        weight: 0,
        prizeType: 'none',
        discountCampaignId: null,
        contentMediaId: null,
      },
      {
        mediaId: null,
        label: '',
        weight: 0,
        prizeType: 'none',
        discountCampaignId: null,
        contentMediaId: null,
      },
      {
        mediaId: null,
        label: '',
        weight: 0,
        prizeType: 'none',
        discountCampaignId: null,
        contentMediaId: null,
      },
      {
        mediaId: null,
        label: '',
        weight: 0,
        prizeType: 'none',
        discountCampaignId: null,
        contentMediaId: null,
      },
      {
        mediaId: null,
        label: '',
        weight: 0,
        prizeType: 'none',
        discountCampaignId: null,
        contentMediaId: null,
      },
      {
        mediaId: null,
        label: '',
        weight: 0,
        prizeType: 'none',
        discountCampaignId: null,
        contentMediaId: null,
      },
      {
        mediaId: null,
        label: '',
        weight: 0,
        prizeType: 'none',
        discountCampaignId: null,
        contentMediaId: null,
      },
      {
        mediaId: null,
        label: '',
        weight: 0,
        prizeType: null,
        discountCampaignId: null,
        contentMediaId: null,
      },
    ],
    style: {
      width: '600px',
      height: '240px',
      backgroundColor: 'rgba(255, 255, 255, 1)',
      fontSize: '18px',
      fontWeight: '700',
      fontFamily: "'Open Sans',sans-serif",
    },
  };

  const _componentTemplates = {
    text: TEXT_TEMPLATE,
    html: HTML_TEMPLATE,
    prizeText: PRIZE_TEXT_TEMPLATE,
    prize: PRIZE_TEMPLATE,
    image: IMAGE_TEMPLATE,
    background: BACKGROUND_TEMPLATE,
    button: BUTTON_TEMPLATE,
    socialButton: SOCIAL_BUTTON_TEMPLATE,
    closeButton: CLOSE_BUTTON_TEMPLATE,
    textField: TEXT_FIELD_TEMPLATE,
    checkbox: CHECKBOX_TEMPLATE,
    dropdown: DROPDOWN_TEMPLATE,
    radio: RADIO_TEMPLATE,
    checkboxGroup: CHECKBOX_GROUP_TEMPLATE,
    hidden: HIDDEN_TEMPLATE,
    countdown: COUNTDOWN_TEMPLATE,
    gridRow: GRID_ROW_TEMPLATE,
    gridColumn: GRID_COLUMN_TEMPLATE,
    scaledStage: SCALED_STAGE_TEMPLATE,
    tab: TAB_TEMPLATE,
    discount: DISCOUNT_TEMPLATE,
    game: GAME_TEMPLATE,
  };

  const FIELD_COMPONENTS = [
    'textField',
    'checkbox',
    'dropdown',
    'radio',
    'checkboxGroup',
    'hidden',
  ];

  function getTemplate(type, formType) {
    const template = WysiwygUtil.cloneJSON(_componentTemplates[type]);
    if (!template) return null;

    template.id = Util.generateId64();

    if ('childComponents' in template) {
      template.childComponents = template.childComponents.map(childComponent => getTemplate(childComponent.type, formType));
    }

    // form type specific template changes
    if (formType === Constants.FormTypes.WELCOME_MAT && type === 'background') {
      template.style.borderTopLeftRadius = 0;
      template.style.borderTopRightRadius = 0;
      template.style.borderBottomLeftRadius = 0;
      template.style.borderBottomRightRadius = 0;
      template.style.width = '100%';
      template.style.height = '100%';
    }

    if (formType === Constants.FormTypes.GAME && type === 'tab') {
      template.mode = 'game';
      template.position = 'center-left';
      template.size = 'small';
    }

    return template;
  }

  function getTemplateJson(type, formType) {
    return JSON.stringify(getTemplate(type, formType));
  }

  function getModifiedTemplate(oldGoal, newGoal, currentTemplate, defaultTemplate) {
    const defaultJSON = JSON.parse(defaultTemplate);
    let currentJSON;

    try {
      currentJSON = JSON.parse(currentTemplate);
    } catch (err) {
      currentJSON = defaultJSON;
    }

    if (oldGoal === 'custom' || _.isEmpty(currentJSON)) {
      return defaultTemplate;
    }

    const { components } = currentJSON.subscribe;
    const hasInputField = _.find(components, value => value.type === 'textField');
    const hasButton = _.find(components, value => value.type === 'button');
    const hasSocial = _.findIndex(components, value => value.type === 'socialButton');

    // Remove social button if not social popup
    if (newGoal !== 'social' && hasSocial > -1) {
      components.splice(hasSocial, 1);
    }

    if (newGoal === 'emails') {
      currentJSON.steps = ['subscribe', 'success'];

      // If there isn't a success popup, create one from template or previous design
      if (!currentJSON.success) {
        if (currentJSON.history && currentJSON.history.success) {
          currentJSON.success = currentJSON.history.success;
        } else {
          currentJSON.success = defaultJSON.success;
        }
      }

      if (!(hasInputField && hasButton)) {
        // Create default email and submit fields from template
        const newEmailField = _.find(defaultJSON.subscribe.components, value => value.type === 'textField' && value.name === 'email');
        const newSubmitField = _.find(defaultJSON.subscribe.components, value => value.action === 'submit');
        // Find redirect button if it exists
        const removedElement = _.findIndex(components, val => val.action === 'redirect' || val.action === 'push');
        const newEmailFieldHeight = parseInt(newEmailField.style.height.match(/\d+/)[0], 10);
        const removedElementPosition = { top: 0, left: 0 };

        // Replace 1st redirect button with new email and submit buttons
        if (removedElement > -1) {
          removedElementPosition.top = parseInt(components[removedElement].style.top.match(/\d+/)[0], 10);
          removedElementPosition.left = parseInt(components[removedElement].style.left.match(/\d+/)[0], 10);
          components.splice(removedElement, 1);

          newEmailField.style.top = `${removedElementPosition.top - newEmailFieldHeight}px`;
          newEmailField.style.left = `${removedElementPosition.left}px`;
          newSubmitField.style.top = `${removedElementPosition.top}px`;
          newSubmitField.style.left = `${removedElementPosition.left}px`;

        // If no redirect buttons to replace, add to bottom of popup
        } else {
          const biggestElement = _.max(components, val => parseInt(val.style.height.match(/\d+/)[0], 10));
          const maxHeight = parseInt(biggestElement.style.height.match(/\d+/)[0], 10);
          newEmailField.style.top = `${maxHeight}px`;
          newSubmitField.style.top = `${maxHeight + newEmailFieldHeight}px`;
        }
        components.push(newEmailField, newSubmitField);
      }
    } else {
      // Preserve push success popup otherwise remove
      if (newGoal !== 'push') {
        currentJSON.steps = ['subscribe'];

        // Save old success popup for later use
        if (currentJSON.success) {
          currentJSON.history = { success: currentJSON.success };
          delete currentJSON.success;
        }
      }

      // Remove/replace buttons based on goal
      for (let i = 0; i < components.length; i += 1) {
        const component = components[i];

        if (component.type === 'button') {
          switch (newGoal) {
            case 'push':
              component.action = 'push';
              break;
            case 'cta':
              component.action = 'redirect';
              break;
            case 'social':
              delete components.splice(i, 1);
              i -= 1;
              break;
            default:
              break;
          }
        }

        // Remove all field types
        if (_.contains(FIELD_COMPONENTS, component.type)) {
          components.splice(i, 1);
          i -= 1;
        }
      }

      // Add button if none
      if (!hasButton && newGoal !== 'social') {
        const actionType = (newGoal === 'push') ? 'push' : 'redirect';
        const newButtonField =
          _.find(defaultJSON.subscribe.components, value => value.action === actionType);
        const biggestElement = _.max(components, val => parseInt(val.style.height.match(/\d+/)[0], 10));
        const maxHeight = parseInt(biggestElement.style.height.match(/\d+/)[0], 10);

        newButtonField.style.top = `${maxHeight}px`;
        components.push(newButtonField);
      }
    }

    return JSON.stringify(currentJSON);
  }

  return {
    getTemplate,
    getTemplateJson,
    getModifiedTemplate,
  };
});
